<script setup>
import { Link, usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

const props = defineProps({
	href: { type: String, required: true },
	prefetch: { type: [Array, String, Boolean], default: undefined },
	cacheFor: { type: String, default: undefined },
})

const settings = usePage().props.settings
const useFullPageLoad = computed(() => settings.google_ads_enabled && settings.google_ads_client_id)
</script>

<template>
	<a v-if="useFullPageLoad" :href="href">
		<slot />
	</a>
	<Link v-else :href="href" :prefetch="prefetch" :cache-for="cacheFor">
		<slot />
	</Link>
</template>
